import Head from "next/head";
import React, { useEffect } from "react";

const TrustpilotListWidget = () => {
  const loadWidget = () => {
    const trustbox = document.getElementById('trustpilot-list-widget');
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(trustbox);
    } else {
      // Trustbox Widget library has not yet downloaded, so wait a bit.
      setTimeout(loadWidget, 200);
    }
  };

  useEffect(() => {
    loadWidget();
  }, []);

  return (
    <>
      <Head>
        <script type="text/javascript" src={ `https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js` } async />
      </Head>

      <div
        id='trustpilot-list-widget'
        data-locale="en-US"
        data-template-id="539ad60defb9600b94d7df2c"
        data-businessunit-id="601882c742c1850001d9c876"
        data-style-height="500px"
        data-style-width="100%"
        data-theme="light"
        data-tags="SelectedReview"
        data-review-languages="en"
        style={{
          width: '100%'
        }}
      >
        <a href="https://www.trustpilot.com/review/daymade.co.uk" target="_blank" rel="noopener">
          Loading Trustpilot Reviews...
        </a>
      </div>
    </>
  );
};

export default TrustpilotListWidget;